import React from "react";
import axios from "axios";
import { connect } from "react-redux";

import { Header, Icon, Button, Image } from "semantic-ui-react";
import { dispatch } from "@rematch/core";

import LoadingComponent from "./../../../common/LoadingComponent";
import NoNewPlanImg from "../../../../images/common/no_new_plans.svg";
let server_url = process.env.REACT_APP_SERVER_URL;

if (!server_url || server_url === "") {
  server_url = `${window.location.protocol}//${window.location.hostname}`;
  if (window.location.port !== "") {
    server_url = `${server_url}:${window.location.port}`;
  }
}

let chargeBeeSiteName = process.env.REACT_APP_CHARGEBEE_SITE_NAME;

if (!chargeBeeSiteName || chargeBeeSiteName === "") {
  chargeBeeSiteName = "aspenify-test";
}

axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

const plansColors = ["alpha", "charlie", "bravo", "delta"];

class UpgradePlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      plans: null,
      loading: "",
      errorMsg: "",
      periodUnit: "month",
    };
    this.upgrade = this.upgrade.bind(this);
  }

  upgrade(planId) {
    let selectPlan = this.state.plans.find((plan) => plan.id === planId);
    if (selectPlan.metadata && selectPlan.metadata.action === 'contact-sales') {
      window.location.href = "https://aspenify.com/about/contact-us/";
      return;
    }
    this.setState({ loading: true });
    const subscriptionId = this.props.subscriptionId;
    const customerId = this.props.selectedAccount.customerId;
    const accountId = this.props.selectedAccount._id;
    const payload = {
      subscriptionId,
      customerId,
      planId,
      accountId,
    };
    dispatch.account.createCustomerSession(payload);
  }

  getUpdatedPlans() {
    const { planId, currencyCode } = this.props;
    const { periodUnit } = this.state;

    let trialUnit;
    if (planId.includes("annual")) {
      trialUnit = "Year";
    } else {
      trialUnit = "month";
    }
    const requestUrl = `${server_url}/plans?currencyCode=${(currencyCode && currencyCode.toLowerCase()) || "usd"}&&periodUnit=${periodUnit}&&usageType=licensed`;
    fetch(requestUrl)
      .then((response) => response.json())
      .then((plans) => this.setState({ plans }));
  }

  componentDidMount() {
    this.getUpdatedPlans();
  }

  handleClick = (e, data) => {
    this.setState({ periodUnit: data.value });
    setTimeout(() => {
      this.getUpdatedPlans();
    }, 10);
  };
  render() {
    let planData = this.state.plans;

    let currencySymbol =
      this.props.currencyCode === "usd"
        ? "$"
        : this.props.currencyCode === "inr"
          ? "₹"
          : this.props.currencyCode === "eur"
            ? "€"
            : this.props.currencyCode === "gbp"
              ? "£"
              : "$";
    let component = null;
    if (planData && planData.length > 0) {
      component = (
        <React.Fragment>
          <div
            className={`price_cards_grid ${this.state.periodUnit === "year" ? "grid-3" : "grid-4"}`}
          >
            {planData
              // .filter((item, i) => { return item.name && !item.name.includes("Enterprise") })
              .map((planDetails, index) => {
                return (
                  <div
                    key={index}
                    className={`price_card ${planDetails.metadata && planDetails.metadata.highlight ? "has-highlight" : "no-highlight"}`}
                  >
                    {this.state.periodUnit === "year" && !(planDetails.metadata && planDetails.metadata.action === 'contact-sales') && (
                      <div className="discount-badge">SAVE 10%</div>
                    )}
                    {planDetails.metadata && planDetails.metadata.highlight && (
                      <div className="highlight-banner">
                        <span className="banner-text">
                          {planDetails.metadata.highlight}
                        </span>
                      </div>
                    )}
                    <div style={{padding: "24px"}}>
                      <div className="header">
                        <span className="name">
                          <div>{planDetails.displayName}</div>
                          {/* Keeping your original badge code here as a fallback/extra icon if needed */}
                          {/* {planDetails.metadata &&
                            planDetails.metadata.highlight && (
                              <div className="highlight-badge-container">
                                <span className="highlight-badge">
                                  {planDetails.metadata.highlight}
                                </span>
                              </div>
                            )} */}
                        </span>
                        <span className="subName">
                          {planDetails.description}
                        </span>

                        {planDetails.metadata && planDetails.metadata.action === 'contact-sales' ? 
                          <div className="price-row" style={{paddingTop:"35px"}}></div> 
                          :<div className="price-row">
                            <div className="currency">{currencySymbol}</div>
                            <div className="amount">{planDetails.price}</div>
                            <div className="unit">
                              per <br />
                              {this.state.periodUnit === "month" ? "month" : "year"}
                            </div>
                          </div>
                        }

                        <button
                          className="stripe-button"
                          onClick={() => this.upgrade(planDetails.id)}
                          disabled={this.props.selectedAccount.planId === planDetails.id}
                        >
                          {this.props.selectedAccount.planId && this.props.selectedAccount.planId === planDetails.id ? "Current Plan" : planDetails.metadata && planDetails.metadata.action === 'contact-sales' ? "Contact Sales" : this.props.selectedAccount.planId ? "Upgrade" : "Subscribe"}
                        </button>
                      </div>

                      <p className="features-header">This includes:</p>
                      <ul className="features">
                        {planDetails.attributes.map((value, index) => (
                          <li key={index}>
                            {value && (
                              <svg
                                className="check-icon"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            )}
                            <p className="attributes">{value}</p>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                );
              })}
          </div>
        </React.Fragment>
      );
    } else {
      if (planData && planData.length === 0) {
        component = (
          <React.Fragment>
            <Image src={NoNewPlanImg} />
            <p textAlign="center" className="f_20">
              No New Plan for Upgrade!
            </p>
          </React.Fragment>
        );
      } else {
        component = (
          <LoadingComponent
            active={true}
            message="Loading Subscription Plans..."
          />
        );
      }
    }

    let pricingTabs = (
      <div className="price-tab">
        <Button.Group>
          <Button
            basic={this.state.periodUnit === "month" ? false : true}
            color={`${this.state.periodUnit === "month" ? null : "red"}`}
            className={`${this.state.periodUnit === "month" ? "planBtnClr" : null}`}
            active={this.state.periodUnit === "month"}
            name="month"
            value="month"
            onClick={(e, data) => this.handleClick(e, data)}
          >
            Monthly
          </Button>
          <Button
            basic={this.state.periodUnit === "year" ? false : true}
            color={`${this.state.periodUnit === "year" ? null : "red"}`}
            className={`${this.state.periodUnit === "year" ? "planBtnClr" : null}`}
            active={this.state.periodUnit === "year"}
            name="year"
            value="year"
            onClick={(e, data) => this.handleClick(e, data)}
          >
            Yearly
          </Button>
        </Button.Group>
      </div>
    );

    // let discount = planData && planData.length === 0 ? null :
    //     <div className="mar_10">Yearly Discount 10%</div>

    return (
      <div id="pricing">
        {pricingTabs}
        {/* {discount} */}
        {component}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    accessToken: state.login.accessToken,
  };
}

const connectedUpgradePlan = connect(mapStateToProps)(UpgradePlan);

export default connectedUpgradePlan;
